import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#771b61',
			dark: '#4d104a',
			light: '#a84c8f',
		},
		secondary: {
			main: '#90B9DA',
		},
		grayscale: {
			main: '#9e9e9e',
			dark: '#424242',
			light: '#f5f5f5',
		},
	},
	typography: {
		fontFamily: ['Montserrat, sans-serif'],
	},
});
